function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:none;stroke:#492cbd;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7233",
  "data-name": "Ellipse 7233",
  className: "cls-3",
  cx: 4.243,
  cy: 4.243,
  r: 4.243,
  transform: "translate(8.486 8.486)"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7234",
  "data-name": "Ellipse 7234",
  className: "cls-3",
  cx: 9.547,
  cy: 9.547,
  r: 9.547,
  transform: "translate(3.182 3.182)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Line_610",
  "data-name": "Line 610",
  className: "cls-3",
  transform: "translate(15.916 15.916)",
  d: "m0 0 3.555 3.555"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Line_611",
  "data-name": "Line 611",
  className: "cls-3",
  transform: "translate(5.995 15.916)",
  d: "M3.555 0 0 3.555"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Line_612",
  "data-name": "Line 612",
  className: "cls-3",
  transform: "translate(5.995 5.995)",
  d: "m0 0 3.555 3.555"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Line_613",
  "data-name": "Line 613",
  className: "cls-3",
  transform: "translate(15.916 5.995)",
  d: "M3.555 0 0 3.555"
});

function SvgHelpCenter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Group_9106",
    "data-name": "Group 9106",
    transform: "translate(-464 -609.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9659",
    "data-name": "Path 9659",
    d: "M27.5 0A27.5 27.5 0 1 1 0 27.5 27.5 27.5 0 0 1 27.5 0z",
    transform: "translate(464 609.42)",
    style: {
      fill: "#492cbd",
      opacity: 0.063
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8907",
    "data-name": "Group 8907",
    transform: "translate(479 624.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9628",
    "data-name": "Path 9628",
    d: "M0 0h25.465v25.465H0z",
    style: {
      fill: "none"
    }
  }), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/help-center.fa8cd6ad.svg";
export { ForwardRef as ReactComponent };